import LoadingSpinner from "./LoadingSpinner";

export default function Button({
  children,
  variant = "primary",
  size = "md",
  type = "button",
  onClick,
  disabled = false,
  loading = false,
  className = "",
  ...props
}) {
  const baseStyles =
    "font-medium rounded-md transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";

  const variants = {
    primary: "bg-primary text-white hover:opacity-90 focus:ring-primary",
    secondary: "bg-secondary text-white hover:opacity-90 focus:ring-secondary",
    danger: "bg-accent text-white hover:opacity-90 focus:ring-accent",
    outline: "border-2 border-border bg-transparent text-text hover:bg-surface",
    ghost: "bg-transparent text-text hover:bg-surface",
  };

  const sizes = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-4 py-2 text-sm",
    lg: "px-6 py-3 text-base",
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {loading ? (
        <LoadingSpinner
          size={size === "sm" ? "sm" : size === "lg" ? "lg" : "md"}
          className="mx-auto"
        />
      ) : (
        children
      )}
    </button>
  );
}
